/**
 * Patient RPC Definitions
 *
 * RPC contracts for patient management operations proxying to DocCirrus API
 */

import { Rpc, RpcGroup } from "effect/rpc";
import { Schema } from "effect";
import { ListPatientsRequestSchema } from "../schemas/patient/list-patients/list-patients.request";
import { ListPatientsResponseSchema } from "../schemas/patient/list-patients/list-patients.response";
import { FindPatientRequestSchema } from "../schemas/patient/find-patient/find-patient.request";
import { FindPatientResponseSchema } from "../schemas/patient/find-patient/find-patient.response";
import { CreatePatientRequestSchema } from "../schemas/patient/create-patient/create-patient.request";
import { CreatePatientResponseSchema } from "../schemas/patient/create-patient/create-patient.response";
import { UpdatePatientRequestSchema } from "../schemas/patient/update-patient/update-patient.request";
import { UpdatePatientResponseSchema } from "../schemas/patient/update-patient/update-patient.response";
import { ExternalAPIErrorSchema, NotFoundErrorSchema } from "../errors";

/**
 * Patient RPC Group
 * Defines the contract for patient operations
 */
export class PatientRpcs extends RpcGroup.make(
  /**
   * PatientList - List patients with optional filters
   */
  Rpc.make("PatientList", {
    success: ListPatientsResponseSchema,
    error: Schema.Union([ExternalAPIErrorSchema, NotFoundErrorSchema]),
    payload: ListPatientsRequestSchema,
  }),

  /**
   * PatientFind - Get a single patient by ID
   */
  Rpc.make("PatientFind", {
    success: FindPatientResponseSchema,
    error: Schema.Union([ExternalAPIErrorSchema, NotFoundErrorSchema]),
    payload: FindPatientRequestSchema,
  }),

  /**
   * PatientCreate - Create a new patient record
   */
  Rpc.make("PatientCreate", {
    success: CreatePatientResponseSchema,
    error: ExternalAPIErrorSchema,
    payload: CreatePatientRequestSchema,
  }),

  /**
   * PatientUpdate - Update an existing patient record
   */
  Rpc.make("PatientUpdate", {
    success: UpdatePatientResponseSchema,
    error: ExternalAPIErrorSchema,
    payload: UpdatePatientRequestSchema,
  })
) {}
